import { render, staticRenderFns } from "./ResendSuccess.vue?vue&type=template&id=5b9779b2&scoped=true&"
var script = {}
import style0 from "./ResendSuccess.vue?vue&type=style&index=0&id=5b9779b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9779b2",
  null
  
)

export default component.exports